export default __webpack_public_path__ + "static/banner-on-any-device-93c757fa711b028d7c1559ac55f526e7.jpeg";